import isEqual from 'lodash/isEqual';
import sortBy from 'lodash/sortBy';
import { IRegion } from '@/creditflowresearch/domain/vo/Region';
import { IProduct } from '@/creditflowresearch/domain/vo/Product';

interface ICommonCollection {
  id: string,
  abbreviation: string,
}

const getNamesParams = <T extends ICommonCollection>(ids:string[], collection:T[]) => collection.reduce(
  (list, item) => (ids.includes(item.id) ? [...list, item.abbreviation] : list),
  [],
).join(',');

interface IGetQueryParamsFromFiltersProps {
  regionsList: IRegion[],
  productsList: IProduct[],
  regionsIds: string[],
  productsIds: string[],
  dateFrom: number | string | null,
  dateTo: number | string | null,
  currentRegions: string,
  currentProducts: string,
}

interface IQueryParams {
  regions?: string,
  products?: string,
  dateFrom?: number | string | null,
  dateTo?: number | string | null,
}

const getQueryParamsForFilters = ({
  regionsList,
  productsList,
  regionsIds,
  productsIds,
  dateFrom,
  dateTo,
  currentRegions,
  currentProducts,
}: IGetQueryParamsFromFiltersProps): IQueryParams => {
  const queryParams: IQueryParams = {};

  const regions = getNamesParams<IRegion>(regionsIds, regionsList);
  const products = getNamesParams<IProduct>(productsIds, productsList);

  if (!isEqual(sortBy(regions), sortBy(currentRegions))) {
    queryParams.regions = regions;
  }

  if (!isEqual(sortBy(products), sortBy(currentProducts))) {
    queryParams.products = products;
  }

  if (dateFrom) {
    queryParams.dateFrom = dateFrom;
  }

  if (dateTo) {
    queryParams.dateTo = dateTo;
  }

  return queryParams;
};

export default getQueryParamsForFilters;
